import { makeObservable, observable, action } from "mobx";

const STORAGE_KEY = 'ssb:mobileVisible';

/**
 * Controls whether the server-stats badge is shown as a floating overlay on mobile
 * (≤768px). Persisted in localStorage; toggled from the chat "..." menu (admins only).
 */
class StatsVisibilityService {
  @observable mobileVisible: boolean = localStorage.getItem(STORAGE_KEY) === '1';

  constructor() {
    makeObservable(this);
  }

  @action
  public toggle(): void {
    this.mobileVisible = !this.mobileVisible;
    localStorage.setItem(STORAGE_KEY, this.mobileVisible ? '1' : '0');
  }
}

const statsVisibilityService = new StatsVisibilityService();
export default statsVisibilityService;
